import {GROUP_TYPE} from '../../canvas-timeline/canvas_timeline_util';
import Group from '../../canvas-timeline/canvas_timeline_group';

class ProjectSubGroup extends Group {
	constructor(data) {
		super(GROUP_TYPE.DATE_RANGE_GROUP, data);
	}
}

export default ProjectSubGroup;
